<template>
	<Dialog :visible="true" :closable="false"  header="Planning Allocation Record" :modal="true" class="p-fluid custom-dialog">
    <div class="p-formgrid p-grid">  
      <div class="p-field p-col">
        <label>Division</label>
        <Dropdown v-model="planningAllocationRecord.division" :options="divisionOptions" optionLabel="name" optionValue="value" placeholder="Select a Division" />
      </div>
      <div class="p-field p-col">
        <label>Department</label>
        <InputText id="department" v-model.trim="planningAllocationRecord.department"/>
      </div>
      <div class="p-field p-col">
        <label>Category</label>
        <InputText id="category" v-model.trim="planningAllocationRecord.category"/>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label>Style</label>
        <InputText id="style" v-model.trim="planningAllocationRecord.style"/>
      </div>
      <div class="p-field p-col">
        <label>Style Name</label>
        <InputText id="style_name" v-model.trim="planningAllocationRecord.style_name"/>
      </div>
      <div class="p-field p-col">
        <label>Color</label>
        <InputText id="color" v-model.trim="planningAllocationRecord.color"/>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label>Size</label>
        <InputText id="size" v-model.trim="planningAllocationRecord.size"/>
      </div>
      <div class="p-field p-col">
        <label>SKU</label>
        <InputText id="sku" v-model.trim="planningAllocationRecord.sku"/>
      </div>
      <div class="p-field p-col">
        <label>UPC<sup v-if="!(dialogType=='bulk-edit')">*</sup></label>
        <InputNumber :useGrouping="false" id="upc" v-model="planningAllocationRecord.upc"/>
        <span class="p-invalid" v-if="submitted && !planningAllocationRecord.upc && !(dialogType=='bulk-edit')">UPC should not be Empty</span>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label>Quantity</label>
        <InputNumber id="qty" v-model="planningAllocationRecord.qty"/>
      </div>
      <div class="p-field p-col">
        <label>From Location</label>
        <InputText id="from_location" v-model.trim="planningAllocationRecord.from_location"/>
      </div>
      <div class="p-field p-col">
        <label>From Location Internal ID</label>
        <InputNumber :useGrouping="false" id="from_location_internal_id" v-model="planningAllocationRecord.from_location_internal_id"/>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label>To Location</label>
        <InputText id="to_location" v-model.trim="planningAllocationRecord.to_location"/>
      </div>
      <div class="p-field p-col">
        <label>To Location Internal ID</label>
        <InputNumber :useGrouping="false" id="to_location_internal_id" v-model="planningAllocationRecord.to_location_internal_id"/>
      </div>
      <div class="p-field p-col">
        <label>PO Season</label>
        <InputText id="po_season" v-model.trim="planningAllocationRecord.po_season"/>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label>Quantity Allocated</label>
        <InputNumber :useGrouping="false" id="qty_allocated" v-model="planningAllocationRecord.qty_allocated"/>
      </div>
      <div class="p-field p-col">
        <label>Quantity Remaining</label>
        <InputNumber :useGrouping="false" id="qty_remaining" v-model="planningAllocationRecord.qty_remaining"/>
      </div>
      <div class="p-field p-col">
        <label>Inventory Transfer</label>
        <InputNumber :useGrouping="false" id="inventory_transfer" v-model="planningAllocationRecord.inventory_transfer"/>
      </div>
    </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="closeDialog"/>
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="handleSubmit(); submitted=true"/>
      </template>
    </Dialog>
</template>

<script>
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Textarea from 'primevue/textarea';
import MultiSelect from 'primevue/multiselect';
import Tooltip from 'primevue/tooltip';
import moment from 'moment';


export default {
  name: "PlanningAllocationForm",
  components: {
    Textarea,
    Button,
    Dialog,
    Dropdown,
    InputText,
    InputNumber,
    MultiSelect
  },
	props: {
		planningAllocationRecord: Object,
    closeDialog: Function,
    handleSubmit: Function,
    dialogType : String
	},
  data() {
    return {
      selectedProducts: null,
      filters: {},
      submitted: false,
      isEditEntryDialoge: false,
      currentDate: new Date().toISOString().slice(0, 10),
      isValidShelfLife: false,
      validDate: false,
      divisionOptions: [
        {name: 'Men', value: 'Men'},
        {name: 'Women', value: 'Women'},
        {name: 'Not Applicable', value: 'Not Applicable'},
      ],
    }
  },
  computed: {
		tester(){
			return "test"
		}
  }
};
</script>

<style>
.custom-dialog .p-inputtext {
  padding: 14px 10px;
  font-size: 16px;
}

.liability-chart.p-inputtext,
.liability-chart.p-dropdown {
  width: 100%;
}

.liability-chart .p-inputtext {
  font-size: 14px;
}
.comment-content {
  color: #00424a;
  font-weight: 700;
}
.hidden {
  display: none;
}
.data-table-parent-container  {
  overflow: hidden;
}

.data-table-parent-container .p-datatable-scrollable-header {
  overflow: unset;
}

.liability-chart.p-datatable .multi-option {
  color: #4d4d4d !important;
  width: 100%;
}
.liability-chart  .p-datatable-tbody > tr.cloned-liabilities-row {
  background: #4d4d4d;
}

.liability-chart .p-datatable-tbody > tr.cloned-liabilities-row > td {
  color: #fff;
}

.liability-count {
  color: #4d4d4d;
  font-size: 12px;
  margin-top: 4px;
}

.data-table-parent-container .p-paginator-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.data-table-parent-container .p-datatable table {
  margin-bottom: 0;
}

.data-table-parent-container .p-datatable .p-datatable-scrollable-footer {
  background: unset;
}

.tool-bar-styling .p-button-info.p-button, .tool-bar-styling .p-button, .tool-bar-styling .p-button.p-button-help {
  background: #00424a;
  border: 1px solid #00424a;
  color: #fff;
}

.tool-bar-styling .p-button-info.p-button:disabled{
  background: #fff;
  border: 1px solid #333;
  color: #000;
  cursor: not-allowed;
}
</style>
